import { Entity, Column, PrimaryGeneratedColumn, CreateDateColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('ledger_excel')
export class LedgerExcel {
  @PrimaryGeneratedColumn()
  id: number;

  @Column('date', {
    name: 'date'
  })
  date: string;

  @Column('int', {
    name: 'division_id'
  })
  divisionId: number;

  @Column('varchar', {
    name: 'file_category'
  })
  fileCategory: string;

  @Column('varchar', {
    name: 'client_code'
  })
  clientCode: string;

  @Column('varchar', {
    name: 'account_type'
  })
  accountType: string;

  @Column('varchar', {
    name: 'account_code'
  })
  accountCode: string;

  @Column('varchar', {
    name: 'description'
  })
  description: string;

  @Column('varchar', {
    name: 'transaction_date'
  })
  transactionDate: string;

  @Column('int', {
    name: 'base_amount'
  })
  baseAmount: number;

  @Column('int', {
    name: 'journal_no'
  })
  journalNo: number;

  @Column('varchar', {
    name: 'journal_type'
  })
  journalType: string;

  @CreateDateColumn({
    name: "created_at",
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    length: 40,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at"
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
}








